import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);
export default new vuex.Store({
    state:{
        show: false,
        stockMoney:'',
        cardNumber:'',
        freeMoney:'',
        tabbar:VueCookies.get('tabbar')==null?0:VueCookies.get('tabbar'),
        // tab1:VueCookies.get('tab1')==null?1:VueCookies.get('tab1'),
    },
    mutations:{
        switch_dialog(state){   //这里的state对应着上面这个state
            this.state.show = state.show ? false : true;
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js